import React from 'react';
import { BrandColor } from '@styleseat/brand';

type StarIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const StarIcon = ({
  width = 16,
  height = 16,
  color = BrandColor.BackInBlack,
  ...restProps
}: StarIconProps) => (
  <svg
    width={height}
    height={width}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.1135 9.92949L3.19602 15.2788L8.00001 12.7532L12.804 15.2788L11.8865 9.92949L15.773 6.14108L10.402 5.36063L8.00001 0.493652L5.59801 5.36063L0.22699 6.14108L4.1135 9.92949ZM11.0332 12.8415L8.00001 11.2468L4.96686 12.8415L5.54614 9.464L3.09227 7.07207L6.48343 6.5793L8.00001 3.50639L9.51658 6.5793L12.9077 7.07207L10.4539 9.464L11.0332 12.8415Z"
      fill={color}
    />
  </svg>
);

export default StarIcon;
